export enum BillsStatuses {
  PAID='paid',
  NOT_PAID='not_paid',
  PARTIALLY_PAID='partially_paid',
  PROCESSING='processing',
}
